import { createAsyncThunk } from "@reduxjs/toolkit";

import { getResponseFormData } from "../selectors/getResponseFormSelectors";
import { getReadingDetailsData } from "../selectors/getReadingDetailsSelectors";

import type { ReadingMessage } from "@/entities/ReadingMessage";
import type { ThunkConfig } from "@/app/providers/StoreProvider";
import type { ApiError } from "@/shared/types";
import { handleError, safelyCaptureException } from "@/shared/lib/helpers/utils";

export const sendMessage = createAsyncThunk<ReadingMessage, void, ThunkConfig<ApiError>>(
  "sendMessage",
  async (_, thunkApi) => {
    const { extra, dispatch, rejectWithValue, getState } = thunkApi;

    const readingDetails = getReadingDetailsData(getState());
    const formData = getResponseFormData(getState());

    const data = new FormData();
    data.append("message", formData.messageText);
    data.append("personality", String(formData.writerPersonality));

    try {
      const response = await extra.api.post<ReadingMessage>(`/api/reading_request_messages/${readingDetails.id}`, data);

      return response.data;
    } catch (err) {
      safelyCaptureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
